// 初期表示
export const PAGE_INIT = "corp/supplychain/PAGE_INIT";
// 選択した項目の詳細情報を取得
export const OTHERS_GET = "corp/supplychain/OTHERS_GET";
